import { useRef } from 'react';

export function useScrollToElement<T extends HTMLElement>(offset = 0) {
  const ref = useRef<T>(null);

  const scrollToElement = () => {
    requestAnimationFrame(() => {
      if (ref?.current) {
        const elementPosition =
          ref.current.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementPosition - offset,
        });
      }
    });
  };

  return { ref, scrollToElement };
}
